import { getWorkspaceImg } from "@/helpers/workspaces";
import { Workspace } from "@/types/workspace";
import React from "react";

type Props = {
  workspace: Partial<Workspace>;
};

const WorkspaceCard = ({ workspace }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <div className="w-[24px] h-[24px] rounded-lg overflow-hidden">
        <img width={24} src={getWorkspaceImg(workspace)} />
      </div>
      <div>
        <div className="text-sm font-medium">{workspace.name}</div>
        <div className="text-xs text-gray-500">{workspace.slug}</div>
      </div>
    </div>
  );
};

export default WorkspaceCard;
